import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { DraftContext } from '../../../../../../contexts/DraftContext'
import DraftUploader from '../../../../../FormComponents/DraftUploader'
import DraftUpload from '../../../../../../models/DraftUpload'
// import DeleteUploadModal from './DeleteUploadModal'
import { useParams } from 'react-router-dom'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import { Archive, Trash3 } from 'react-bootstrap-icons'
import axiosService from '../../../../../../utils/AxiosService'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'

export default observer(function UploadSelectPanel({ action }) {
  const { selectedUpload, campaignState } = useContext(SharedCampaignContext)

  return (
    <div className='my-5 p-3 w-[650px] border-1 border-primary dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode rounded-lg overflow-hidden'>
      <div className='flex justify-between items-center'>
        <h3 className='mb-2 pt-1 font-bold text-md dark:text-white'>{action.draft_uploads.length > 0 ? selectedUpload.fileName : 'No uploads'}</h3>
      </div>
      <div className='flex items-center justify-start gap-4 min-w-full overflow-x-scroll'>
        {
          action?.draft_uploads.map((upload) => (
            <button
              key={upload.id}
              type='button'
              onClick={() => {
                campaignState.commentable = false
                campaignState.selectedUpload = upload
              }}
              className='relative'
            >
              <img
                src={upload.videoThumb || upload.url}
                alt={upload.fileName}
                className={`${selectedUpload.id === upload.id ? 'border-2 border-rb-green dark:border-rb-green' : ''} h-12 min-w-12 max-w-12 rounded-lg object-cover`}
              />
            </button>
          ))
        }
      </div>
    </div>
  )
})
